import { render, staticRenderFns } from "./AdmissionDetails.vue?vue&type=template&id=a41e9a88&"
import script from "./AdmissionDetails.vue?vue&type=script&lang=js&"
export * from "./AdmissionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports